const AssignmentCardSpecialInstructions = ({
  specialInstructions,
}: {
  specialInstructions: string;
}) => {
  return (
    <div className="p-2 m-2 border rounded border-neutral-500">
      <div className="mb-2 p-2 d-flex align-items-center gap-2">
        {specialInstructions}
      </div>
    </div>
  );
};

export default AssignmentCardSpecialInstructions;
